<script setup lang="ts">
import { computed } from 'vue'
import InputText from 'primevue/inputtext'

const props = defineProps<{
  modelValue?: string
}>()

const emit = defineEmits(['update:modelValue'])

const value = computed({
  get: () => props.modelValue,
  set: (newVal?: string) => emit('update:modelValue', newVal)
})

</script>

<template>
  <div class="flex flex-col gap-2">
    <label for="last-edited-by">Last Edited By:</label>
    <InputText
      id="last-edited-by"
      v-model="value"
      placeholder="N/A"
      disabled
    />
  </div>
</template>

<style scoped>

</style>